/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SaveAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaModalFooterAction from 'DesignSystem/TysiaModal/TysiaModalFooter/TysiaModalFooterAction/index'



/** @type {import('Simple/types.js').View} */
export default function SaveAction({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/EditLength/Content/SaveAction",
  onSubmit,
  isSubmitting
  
}) {
let editLengthSubmitData = fromData.useDataSubmit({ viewPath,
context: 'edit_length',
})
let editLengthIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'edit_length',
})
  return (<React.Fragment
>
<TysiaModalFooterAction
  viewPath={`${viewPath}/TysiaModalFooterAction`}
 data="edit_length"
 onClick={editLengthSubmitData}
 disabled={editLengthIsSubmittingData}
 text="Save"
/>
{children}
</React.Fragment>)
}